import React, { useState, useEffect} from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import AboutUs from './AboutUs';
import Leaderboard from './Leaderboard';
import Library from './Library';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import './SidePanel.css';
import AddIcon from '@mui/icons-material/Add';
import AboutUsIcon from '@mui/icons-material/Groups';
import LeaderBoardIcon from '@mui/icons-material/BarChart';
import HomeIcon from '@mui/icons-material/Home';
import BrowseGalleryIcon from '@mui/icons-material/BrowseGallery';
import { SignIn, SignInIcon } from "./SignIn";
import Logo from './assets/video-arena-logo-gradient.svg';

import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';

const SidePanel = (props) => {
    const [isOpen, setIsOpen] = useState(true);
    let navigate = useNavigate();

    useEffect(() => {
        console.log("----- enter SidePanel");
    
        return () => {
          console.log("----- exit SidePanel");
        }
    }, []);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const onAddClick = () => {
        console.log("----- onAddClick");
    };

    const navigateTo = (path) => {
        navigate(path);
    };

    return (
        <div className={`side-panel-container ${isOpen ? 'open' : ''}`}>
            <div className={`side-panel ${isOpen ? 'open' : ''}`}>
                <div className="side-panel-logo-container">
                    <img src={Logo} alt="Logo" className="side-panel-logo" />
                    <button className="side-panel-toggle" onClick={toggleSidebar}>
                        <img src={isOpen ? './sidebar-panel-collapse-icon.svg' : './sidebar-panel-expand-icon.svg'} alt="Toggle Sidebar" />
                    </button>
                </div>

                {isOpen && (
                    <div className="side-panel-top-button-container">
                        <div className="side-panel-button-container">
                            <button className="side-panel-icon-hover-button" onClick={() => navigateTo('/')}>
                                <HomeIcon className="side-panel-button-icon" />
                                <span className="side-panel-button-text">Home</span>
                            </button>
                            <button className="side-panel-icon-hover-button" onClick={() => props.toggle(true)}>
                                <AddIcon className="side-panel-button-icon" />
                                <span className="side-panel-button-text">Submit Prompt</span>
                            </button>
                            <button className="side-panel-icon-hover-button" onClick={() => navigateTo('/leaderboard')} >
                                <LeaderBoardIcon className="side-panel-button-icon" />
                                <span className="side-panel-button-text">Leaderboard</span>
                            </button>
                            <button className="side-panel-icon-hover-button" onClick={() => navigateTo('/about')}>
                                <AboutUsIcon className="side-panel-button-icon" />
                                <span className="side-panel-button-text">About Us</span>
                            </button>
                            {/* <button className="side-panel-icon-hover-button" onClick={() => navigateTo('/library')}>
                                <BrowseGalleryIcon className="side-panel-button-icon" />
                                <span className="side-panel-button-text">Library</span>
                            </button>
                            <Library baseURL={props.baseURL} userId={props.userId} library={props.library} setLibrary={props.setLibrary} curVid={props.curVid} setCurVid={props.setCurVid} type='list'></Library> */}
                        </div>
                        <SignIn userId={props.userId} setUserId={props.setUserId} baseURL={props.baseURL}/>
                    </div>
                )}

                {!isOpen && (
                    <div className="side-panel-top-button-container">
                        <div className="side-panel-button-container-collapse">
                            <button className="side-panel-icon-hover-button-collapse" onClick={() => navigateTo('/')}>
                                <HomeIcon className="side-panel-button-icon" />
                            </button>
                            <button className="side-panel-icon-hover-button-collapse" onClick={() => props.toggle(true)}>
                                <AddIcon className="side-panel-button-icon" />
                            </button>

                            <button className="side-panel-icon-hover-button-collapse" onClick={() => navigateTo('/leaderboard')}>
                                <LeaderBoardIcon className="side-panel-button-icon" />
                            </button>
                            <button className="side-panel-icon-hover-button-collapse" onClick={() => navigateTo('/about')}>
                                <AboutUsIcon className="side-panel-button-icon" />
                            </button>
                            {/* <button className="side-panel-icon-hover-button-collapse" onClick={() => navigateTo('/library')}>
                                <BrowseGalleryIcon className="side-panel-button-icon" />
                            </button> */}
                        </div>
                        <SignInIcon userId={props.userId} setUserId={props.setUserId} baseURL={props.baseURL}/>
                    </div>
                )}

            </div>
        </div>
    );
};

export default SidePanel;